import {Component, OnDestroy, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { fuseAnimations } from '@barebone-fuse/@fuse/animations';
import {Location} from '@angular/common';
import {TaskManagerState} from '../../store/task-manager.reducer';
import {SecurityState} from '@shared/store/reducers/security.reducer';

@Component({
    standalone: false,
    selector: 'particle-task-manager',
  templateUrl: './task-manager.component.html',
  styleUrls: ['./task-manager.component.scss'],
  animations: fuseAnimations
})

export class TaskManagerContentComponent implements OnInit, OnDestroy {
  dialogRef: any;
  disableDeleteButton$: boolean;
  selectedItems: any[];
  hasFeature$: Observable<any>;
  companyBoards$: any;
  companyBoards: any;
  supportBoards$: any;
  supportBoards: any;
  boardView = false;
  constructor(public dialog: MatDialog,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private location: Location,
              private taskManagerStore: Store<TaskManagerState>,
              private securityStore: Store<SecurityState>) {
    this.selectedItems = [];
  }

  ngOnInit() {

  }

  ngOnDestroy() {
  }

  onSelectionChanged(selectedItems: any[]) {

  }
  openDialog() {

  }
  deleteContacts() {

  }

  navigateToContactImport() {

  }

}
